import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from './plugins/element-ui'
import inject from './plugins/inject'
import { downloadBlobResponse } from './utils/download'

// document.title = '课本征订平台'; // 已在 vue.config.js 中配置

// 按需注册 Element UI，避免全量组件进入 chunk-vendors
Vue.use(ElementUI)
// 挂载到vue上
Vue.use(inject)

Vue.config.productionTip = true
window.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$tableHeight = window.innerHeight - 260

Vue.prototype.$download = function (res, name) {
  return downloadBlobResponse(res, name)
}

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 如果进入到的路由是登录页或者注册页面，则正常展示
  if (window.sessionStorage.getItem('token') || to.path == '/login') {
    if (to.path == '/login') {
      // 如果是登录页面就把框架去掉
      router.app.$store.commit('showFramework', false)
    } else {
      if (to.matched.length === 0) { // 如果路由不匹配任何路由规则
        next('/404') // 重定向到404页面
      }
      router.app.$store.commit('showFramework', true)
    }
    // 直接放行
    next()
  } else {
    router.app.$store.commit('showFramework', false)
    // 跳转到登录页面
    console.log(to)
    next({
      path: '/login'
    })
  }
})
